import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';
import { publicDPRoot } from '../../public-meta';

const dpRoot = `${publicDPRoot}|SSO`;

export type CPSSOErrorLoc =
	| 'CPSSOErrorMessage'
	| 'CPSSOErrorCustomVueEgress'
	| 'CPSSOErrorTryAgain'
	| 'CPSSOErrorCustomVueSupport';

export const cpSSOErrorLocs: LocDefs<CPSSOErrorLoc> = {
	CPSSOErrorMessage: {
		defaultValue: 'There was a problem logging in.',
		description: 'Error message displayed when there is a problem logging via SSO.',
		displayPath: `${dpRoot}|Error Message`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegration,
		portal: 'CP',
		htmlAllowed: true,
		legacyName: 'CandidateAccess.Integration.Ingress/Login.SSO.Content.ErrorMessage',
	},
	CPSSOErrorTryAgain: {
		defaultValue: 'Try Again',
		description: 'Try again button for the SSO error page.',
		displayPath: `${dpRoot}|Try Again`,
		displayType: 'Button',
		feature: HubFeature.CandidateAccessIntegration,
		portal: 'CP',
		legacyName: 'CandidateAccess.Integration.Ingress/Login.SSO.Button.ErrorTryAgain',
	},
	CPSSOErrorCustomVueEgress: {
		defaultValue: 'There was a problem with your account at Pearson Vue',
		description:
			'Error message displayed when there is a problem logging via SSO due to specific Pearson Vue block.',
		displayPath: `${dpRoot}|SSO Vue Error Message`,
		displayType: 'Button',
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
		portal: 'CP',
	},
	CPSSOErrorCustomVueSupport: {
		defaultValue: 'Contact Pearson Vue',
		description: 'HTML content for Pearson Vue support link.',
		displayPath: `${dpRoot}|Pearson Vue Support Content`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
		portal: 'CP',
		htmlAllowed: true,
	},
};

export const LOC_KEYS = MapLocKeys<CPSSOErrorLoc>(cpSSOErrorLocs);

export type CPSSOErrorLocType = LocMap<CPSSOErrorLoc>;
